import { useRecoilValue } from 'recoil';

import { selectedOrganization, organizationList } from './atoms';

export const useSelectedOrganization = () => useRecoilValue(selectedOrganization);

export const useOrgnizationList = () => useRecoilValue(organizationList);
